import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderStripe, StripeService } from 'gung-standard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayStripeService extends StripeService {
  public getOrderStripe(storageId: string): Observable<OrderStripe> {
    const urlString = `json/order-stripe/${storageId}`;
    return this.http.get<OrderStripe>(urlString);
  }
}
